import React from "react";
import { Box, Typography } from "@mui/material";
import { usePartFormatter } from "../../../hook/usePartFormatter";

interface TPartBasicInfoComponentProps {
    item: any;
}

const PartBasicInfoComponent = (props: TPartBasicInfoComponentProps) => {
    const partFormatter = usePartFormatter();

    return (
        <Box>
            <Typography variant="h6">
                {props.item.itemCode || "-"} /{" "}
                {props.item.itemDescription || "-"}
            </Typography>
            <Typography variant="body1">
                {partFormatter.getNavContextByData(
                    props.item.machineSN,
                    props.item.table,
                    props.item.position
                )}
            </Typography>
        </Box>
    );
};

export default PartBasicInfoComponent;
